import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ihm-select-all-checkbox',
  templateUrl: './ihm-select-all-checkbox.component.html'
})
export class IhmSelectAllCheckboxComponent {
  @Input() readonly control: AbstractControl;
  @Input() readonly values: any[] = [];
  @Input() readonly text: string = 'Select All';

  @Output() readonly selectAllToggled: EventEmitter<any> = new EventEmitter<any>();

  isChecked(): boolean {
    return this.control.value && this.values.length && this.control.value.length === this.values.length;
  }

  isIndeterminate(): boolean {
    return this.control.value && this.values.length && this.control.value.length && this.control.value.length < this.values.length;
  }

  toggleSelection(checked: boolean): void {
    if (checked) {
      this.control.setValue(this.values);
    } else {
      this.control.setValue([]);
    }
    this.selectAllToggled.emit(this.control.value);
    this.control.markAsDirty();
  }
}
